<template>
  <div class="ui-skeleton" :style="styleList">
    <div class="ui-skeleton__loader">
      <slot></slot>
    </div>
  </div>
</template>

<script>
const convertToPx = size => size ? `${parseFloat(size)}px` : ''
const LINE_HEIGHT_NORMAL = 'normal'

export default {
  name: 'UiSkeleton',
  mounted () {
    this.setStyle()
  },
  data () {
    return {
      styleList: {
        height: '',
        flexGrow: '',
        maxWidth: '',
        width: '',
        borderRadius: '',
        marginTop: '',
        marginBottom: '',
        marginLeft: '',
        marginRight: '',
        paddingTop: '',
        paddingBottom: '',
        fontSize: '',
        lineHeight: ''
      }
    }
  },
  props: {
    text: {
      type: Boolean,
      default: false
    },
    height: Number,
    width: Number,
    maxWidth: Number,
    marginTop: Number,
    marginBottom: Number,
    marginLeft: Number,
    marginRight: Number,
    borderRadius: Number,
    fontSize: Number,
    lineHeight: Number
  },
  methods: {
    setStyle () {
      this.styleList = {
        ...this.styleList,
        height: convertToPx(this.height),
        width: convertToPx(this.width),
        borderRadius: convertToPx(this.borderRadius),
        marginTop: convertToPx(this.marginTop),
        marginBottom: convertToPx(this.marginBottom),
        marginLeft: convertToPx(this.marginLeft),
        marginRight: convertToPx(this.marginRight),
        fontSize: convertToPx(this.fontSize),
        lineHeight: convertToPx(this.lineHeight)
      }
      if (this.maxWidth) {
        this.styleList.maxWidth = convertToPx(this.maxWidth)
        this.styleList.width = '100%'
        this.styleList.flexGrow = 1
      }

      if (this.text) {
        this.setTextHeight()
      }
    },
    setTextHeight () {
      const style = getComputedStyle(this.$el)
      const lineHeight = this.lineHeight ?? style.lineHeight
      const fontSize = this.fontSize ?? style.fontSize

      if (lineHeight === LINE_HEIGHT_NORMAL) {
        this.styleList.height = convertToPx(fontSize)
        return
      }

      this.styleList.height = convertToPx(lineHeight)
      const paddingY = (parseInt(lineHeight) - parseInt(fontSize)) / 2
      this.styleList.paddingTop = this.styleList.paddingBottom = convertToPx(paddingY)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-skeleton {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: $skeleton-border-radius;

  &__loader {
    position: relative;
    height: 100%;
    flex-grow: 1;
    overflow: hidden;
    border-radius: inherit;
    background-color: $gray-7;

    &::before {
      content: '';
      display: block;
      position: absolute;
      left: -150px;
      top: 0;
      height: 100%;
      width: 150px;
      background: linear-gradient(to right, transparent 0%, #fff 50%, transparent 100%);
      animation: load 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
    }
  }
}

@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}
</style>
